var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}pause-24`,"viewBox":"0 0 24 24"}},[_c('circle',{staticClass:"base",attrs:{"cx":"12","cy":"12","r":"12"}}),_c('rect',{staticClass:"sign",attrs:{"x":"13","y":"9","width":"2","height":"6"}}),_c('rect',{staticClass:"sign",attrs:{"x":"9","y":"9","width":"2","height":"6"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }